import React from 'react';
import { FaTrash } from 'react-icons/fa';

interface DeletedIndicatorProps {
  isDeleted: boolean;
  className?: string;
  title?: string;
}

export const DeletedIndicator: React.FC<DeletedIndicatorProps> = ({
  isDeleted,
  className = '',
  title = 'Deleted',
}) => {
  if (!isDeleted) {
    return null;
  }

  return <span className={`badge bg-danger ms-4 ${className}`}>{title}</span>;
};

export default DeletedIndicator;
